/*
 * @Author: Teemo Ding
 * @Date: 2021-10-19 14:07:58
 * @LastEditTime: 2022-06-10 13:38:30
 * @LastEditors: Json Chen
 * @FilePath: /unifyxp-v2-store-portal/src/pages/SalesCannelVersion/SalesChannelSettings/SalesChannelMiniProgramSetting/MiniProgramPreview/index.tsx
 */

import { Button, SizeFittingTable } from '@/src/components/Antd';
import ErrorModal from '@/src/components/ErrorModal/ErrorModal';
import ErrorModalTitle from '@/src/components/ErrorModal/ErrorModalTitle';
import SectionWrapper from '@/src/components/Layouts/Section/SectionWrapper';
import { getSalesChannelTimezoneGmt } from '@/src/constrains/SalesChannelHOC/slice';
import {
  request_generateQrCode,
  request_review,
} from '@/src/request/salesChannel/setting/miniProgramSetting';
import { Icon } from '@/src/tools/icon';
import { useRequest } from 'ahooks';
import { get } from 'lodash';
import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import { useI18n } from 'src/hooks/useRouterChange';
import { i18nGet } from 'src/tools/tools';
import ScanQRCode from '../Components/ScanQRCode';
import { previewColumns } from '../config';
import css from '../css.module.less';

const MiniProgramPreview = ({
  onUploadCodeVersion,
  preview,
  setShowModal,
  setModalTitle,
  setModalContent,
  runLandingPage,
  submitCodeVersionConfirm,
  disabled,
}) => {
  const timezoneGmt = useSelector(getSalesChannelTimezoneGmt());
  const i18n = useI18n();
  const getI18n = (str) => i18nGet(i18n, str);
  const [fold, setFold] = useState(false);
  const { run: runReview } = useRequest((uuid) => request_review(uuid), {
    manual: true,
    ready: !disabled,
    onSuccess: () => {
      runLandingPage();
    },
  });
  const { run: runGenerateQrCode } = useRequest(
    (data) => request_generateQrCode(data),
    {
      manual: true,
      ready: !disabled,
      onSuccess: (data) => {
        //TODO Generate QR Code
        handleGenerateQrCode(`data:image/png;base64, ${(data || {}).data}`);
      },
    },
  );

  const handleGenerateQrCode = (url) => {
    setShowModal(true);
    setModalTitle(
      getI18n('salesChannelMiniProgramSettings.index.scanQRCodeToPreview'),
    );
    setModalContent(<ScanQRCode url={url} />);
  };

  const handleSubmitConfirmModal = (uuid) => {
    setShowModal(true);
    setModalTitle(
      <ErrorModalTitle>
        {getI18n(
          'salesChannelMiniProgramSettings.index.submitCodeVersionForTencentReview',
        )}
      </ErrorModalTitle>,
    );
    setModalContent(
      <ErrorModal
        setModal={setShowModal}
        onSubmit={() => runReview(uuid)}
        errorText={getI18n(
          'salesChannelMiniProgramSettings.index.submitCodeVersionModalContent',
        )}
        okText={getI18n('general.confirm')}
      />,
    );
  };

  const handleUploadConfirmModal = () => {
    setShowModal(true);
    setModalTitle(
      <ErrorModalTitle>
        {getI18n('salesChannelMiniProgramSettings.index.uploadCodeVersion')}
      </ErrorModalTitle>,
    );
    setModalContent(
      <ErrorModal
        setModal={setShowModal}
        hideOKCancel
        onSubmit={onUploadCodeVersion}
        errorText={getI18n(
          'salesChannelMiniProgramSettings.index.uploadCodeVersionModalContent2',
        )}
        okText={getI18n('general.confirm')}
      />,
    );
  };

  return (
    <SectionWrapper
      titleClassName={css.titleContainer}
      containerClassName={css.logoWrapper}
      titleOnClick={() => setFold(!fold)}
      hideContent={!fold}
      rightPart={<Icon type={fold ? 'icondown1' : 'iconright'} />}
      title={getI18n(
        'salesChannelMiniProgramSettings.index.miniProgramUploadandPreview',
      )}>
      <h3>
        {getI18n(
          'salesChannelMiniProgramSettings.index.miniProgramUploadandPreview',
        )}
      </h3>
      <p>
        {getI18n(
          'salesChannelMiniProgramSettings.index.miniProgramUploadandPreviewTips',
        )}
      </p>
      <SizeFittingTable
        rowKey='uuid'
        pagination={false}
        id='codeVersionPreview'
        columns={previewColumns(
          submitCodeVersionConfirm ? handleSubmitConfirmModal : runReview,
          runGenerateQrCode,
          disabled,
          timezoneGmt,
          { getI18n },
        )}
        dataSource={preview ? [preview] : []}
        rowSelection={false}
      />
      <Button
        type='primary'
        className={css.submitForPreview}
        onClick={() =>
          get(preview, 'uuid', '')
            ? handleUploadConfirmModal()
            : onUploadCodeVersion()
        }
        disabled={disabled}>
        {getI18n('salesChannelMiniProgramSettings.index.uploadCodeVersion')}
      </Button>
    </SectionWrapper>
  );
};

export default MiniProgramPreview;
